import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { closeSnackbar, getSnacks, initSnacksQueue } from 'ducks/ux'

export const useSnackbar = () => {
  // a queue of snacks per type, from the untyped ux slice
  const snacks = useSelector(getSnacks) as Record<string, unknown[]>
  const dispatch = useDispatch()

  const activeSnacks = React.useMemo(
    () =>
      Object.values(snacks)
        .map(queue => queue[0])
        .filter(Boolean),
    [snacks],
  )

  const handleShowSnackbar = React.useCallback(
    ({
      message,
      type,
      timeout,
    }: {
      message: string
      type: string
      timeout?: number
    }) => {
      dispatch(initSnacksQueue({ message, type, timeout }))
    },
    [dispatch],
  )

  const handleHideSnackbar = React.useCallback(
    ({ id, type }) => {
      dispatch(closeSnackbar({ id, type }))
    },
    [dispatch],
  )

  return {
    state: { snacks: activeSnacks },
    handlers: {
      handleShowSnackbar,
      handleHideSnackbar,
    },
  }
}
